import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import {
  EDIT_POLICY_ROUTE,
  MARKET_SCAN_LIFE_REFERRAL,
  MARKET_SCAN_NEW_DEFAULT_ROUTE,
  MARKET_SCAN_NEW_ROUTE,
  MARKET_SCAN_RESULTS_ROUTE,
  MARKET_SCAN_COMPARE_POLICY_ROUTE,
  POLICY_DETAILS_ROUTE,
  RENEWAL_ROUTE,
  MARKET_SCAN_RESULTS_LIFE_ROUTE,
  MARKET_SCAN_ROUTE,
  EXPLORE_DISCOVER_POLICY_INFO_ROUTE,
  MARKET_SCAN_STATUS_ROUTE,
  MARKET_SCAN_SELECTION_ROUTE,
  MARKET_SCAN_SELECTION_ADD_ROUTE,
} from 'constants/routes';
import { IPolicy } from 'types';

export const getPolicyDetailsRoute = (policyId: string) => {
  return POLICY_DETAILS_ROUTE.replace(':id', policyId);
};

export const getPolicyRenewalRoute = (policyId: string) => {
  return RENEWAL_ROUTE.replace(':id', policyId);
};

export const getRenewalEndRoute = (policy: IPolicy) => {
  return !policy.adviserOrgId && getPolicyDetailsRoute(policy.id);
};

export const getMarketScanNewRouteByName = (policyTypeName: string) => {
  if (policyTypeName === INSURANCE_TYPES_NAMES.OTHER) {
    return MARKET_SCAN_NEW_DEFAULT_ROUTE;
  }
  const cleanedPolicyTypeName = policyTypeName.replace('/', '-');
  return MARKET_SCAN_NEW_ROUTE.replace(
    ':policyTypeName?',
    cleanedPolicyTypeName,
  );
};

const withPolicyTypeName = (route: string, policyTypeName: string) =>
  route.replace(':policyTypeName', policyTypeName.replace('/', '-'));

export const getMarketScanSelectionRouteByName = (policyTypeName: string) =>
  withPolicyTypeName(MARKET_SCAN_SELECTION_ROUTE, policyTypeName);

export const getMarketScanSelectionAddRouteByName = (policyTypeName: string) =>
  withPolicyTypeName(MARKET_SCAN_SELECTION_ADD_ROUTE, policyTypeName);

export const getMarketScanNewLifeRoute = () => {
  return MARKET_SCAN_NEW_ROUTE.replace(
    ':policyTypeName?',
    INSURANCE_TYPES_NAMES.LIFE,
  );
};

export const getMarketScanNewLifeReferralRouteByName = (
  policyTypeName: string,
) => {
  return MARKET_SCAN_LIFE_REFERRAL.replace(':policyTypeName?', policyTypeName);
};

export const getMarketScanResultsRoute = (id: string, sk: string) => {
  return `${MARKET_SCAN_RESULTS_ROUTE}?id=${id}&sk=${sk}`;
};

export const getMarketScanLifeResultsRoute = (id: string, sk: string, waitTime?: number) => {
  if (waitTime) {
    return `${MARKET_SCAN_RESULTS_LIFE_ROUTE}/?id=${id}&sk=${sk}&waitingTime=${waitTime}`;
  }
  return `${MARKET_SCAN_RESULTS_LIFE_ROUTE}/?id=${id}&sk=${sk}`;
};

export const getEditPolicyRoute = (id: string) =>
  EDIT_POLICY_ROUTE.replace(':id', id);

export const routeReplaceParams = (route, obj) => {
  return Object.keys(obj).reduce((acc, key) => {
    return acc.replace(`:${key}`, obj[key]);
  }, route);
};

export const routeReplaceId = (route: string, id: string) =>
  routeReplaceParams(route, { id });

export const getComparePolicyRoute = (id: string) => {
  return routeReplaceId(MARKET_SCAN_COMPARE_POLICY_ROUTE, id);
};

export const getMarketScanEndScreenRoute = (id: string, payload?: any) => {
  return {
    pathname: MARKET_SCAN_STATUS_ROUTE,
    search: `?id=${id}`,
    state: { payload },
  };
};

export const getWikiRouteByName = (policyType: string) => {
  return EXPLORE_DISCOVER_POLICY_INFO_ROUTE.replace(':policyName', policyType);
};
